export default {
    recommendations: 'Recommendations: {{count}}',
    recommendationAbbr: 'r',
    claims: 'Claims: {{count}}',
    claimsAbbr: 'c',
    badPartners: 'Mentions on "Unfair Partners" forum": {{count}} from {{firmCount}} {{string}}',
    badPartnersAbbr: 'up',
    oneFirm: 'users',
    twoFirms: 'users',
    manyFirms: 'users',
    otherFirms: 'users',
};
    
